(function () {
  'use strict';

  var dictionary = window.LpcJourneyI18n || {};
  if (!dictionary || document.documentElement.lang === 'fr') return;

  function text(key, variables) {
    var value = dictionary[key] || '';
    Object.keys(variables || {}).forEach(function (name) {
      value = value.split('[' + name + ']').join(String(variables[name]));
    });
    return value;
  }

  function composerText(key) {
    return (
      (window.LpcI18n &&
        window.LpcI18n.composer &&
        window.LpcI18n.composer[key]) ||
      ''
    );
  }

  var exact = {
    "L'essentiel": 'formula_essential',
    'Le Duo': 'formula_duo',
    'La Famille': 'formula_family',
    '800+ avis': 'reviews_count',
    'Modèle.': 'model_one',
    'Modèles.': 'model_other',
    'Modifier': 'modify',
    'Configurer →': 'configure_arrow',
    'épuisé': 'sold_out',
    '★ Best-seller': 'badge_bestseller',
    'Stock en baisse': 'badge_low_stock',
    'RUPTURE': 'badge_sold_out',
    'Rupture': 'badge_sold_out',
    'Nouveau': 'badge_new',
    'Aucun produit dans cette collection.': 'no_products',
    'couleur ?': 'color_unknown',
    'Pack cadeau offert': 'gift_pack_free',
    'OFFERT': 'free',
    'Offert': 'gift',
    'offert': 'free_lower',
    'Coque MagSafe': 'magsafe_case',
    'Remise': 'discount',
    'Livraison': 'shipping',
    'Livraison gratuite': 'delivery_free',
    'Inclus': 'included_m',
    'Incluse': 'included_f',
    'Charge 15W': 'standard_charge',
    'Rallonge USB-C 1 m': 'extension_name',
    'Adaptateur secteur 55 W': 'adapter_name',
    'Ajout en cours...': 'add_in_progress',
    'pack': 'pack',
    'promo': 'promo',
    'Sélectionner un modèle': 'select_model',
    'Sélectionné — cliquez pour changer': 'selected_change',
    'Passez en pack Duo.': 'heading_duo',
    'Passez en pack Famille.': 'heading_family',
    'Ajouter au panier': 'add_to_cart',
    'Ajouter la coque au panier': 'add_case_one',
    'Ajouter les coques au panier': 'add_case_other',
    'Ajouter': 'add_generic',
    'Le montant total de votre panier est de': 'hero_total_prefix',
    'Vous économisez': 'hero_savings_prefix',
    'sur ce panier.': 'hero_savings_suffix',
    'Profitez de la livraison gratuite et de retours gratuits.': 'hero_no_savings',
    'Livraison standard à 9,90 €, offerte dès 50 €. Frais de retour à votre charge.': 'hero_no_savings',
    'Valider la commande': 'checkout',
    'Payer avec Apple Pay': 'pay_apple',
    'Supprimer': 'remove',
    'économisés': 'saved',
    "Commandez aujourd'hui.": 'order_today',
    'Expédié sous 24 heures · Livraison gratuite': 'shipped_free',
    'Dernière journée': 'promo_last_day',
    'Promo.': 'promo_heading',
    'Début': 'promo_start',
    'Fin': 'promo_end',
    'Cette promo se termine ce soir à minuit': 'promo_ends',
    'Sous-total': 'subtotal',
    'Remise pack': 'pack_discount',
    'Accessoires offerts': 'gift_discount',
    'Remises': 'discounts',
    'Gratuite': 'free_f',
    'Total': 'total',
    'TVA et frais légaux inclus.': 'tax',
    "Besoin d'une aide supplémentaire ?": 'help_prefix',
    'Chattez en ligne': 'chat_online',
    'ou écrivez-nous à': 'or_write',
    'ChargerCare souscrite': 'chargercare_subscribed',
    'Ne plus prendre cette garantie': 'chargercare_remove',
    'Protégez vos chargeurs.': 'protect_chargers',
  };

  var frenchMonths = [
    'janvier',
    'février',
    'mars',
    'avril',
    'mai',
    'juin',
    'juillet',
    'août',
    'septembre',
    'octobre',
    'novembre',
    'décembre',
  ];
  var locale = document.documentElement.lang || 'en';
  var localizedMonths = frenchMonths.map(function (_, index) {
    return new Intl.DateTimeFormat(locale, { month: 'long' }).format(
      new Date(2024, index, 1),
    );
  });

  function translateMonths(value) {
    var result = value;
    frenchMonths.forEach(function (month, index) {
      result = result.replace(
        new RegExp('\\b' + month + '\\b', 'gi'),
        localizedMonths[index],
      );
    });
    return result;
  }

  function translateCore(value) {
    if (!value) return value;
    if (exact[value]) return text(exact[value]);

    var composerExact = {
      'Quel modèle vous faut-il ?': 'which_model',
      'Quels modèles vous faut-il ?': 'which_models',
      'À configurer': 'to_configure',
      'Charge simultanée iPhone + Apple Watch + AirPods.':
        'trio_desc',
      'Charge un seul appareil (iPhone). Plus compact, plus minimaliste.':
        'solo_desc',
      'Protégez votre nouveau chargeur.': 'protect_charger',
      'Protégez vos nouveaux chargeurs.': 'protect_chargers',
      'Compléter votre pack': 'complete_your_pack',
      'Compléter votre pack →': 'complete_your_pack_arrow',
      'Votre nouveau chargeur.': 'your_new_charger',
      'Vos nouveaux chargeurs.': 'your_new_chargers',
      'Câble USB-C tressé': 'braided_cable',
      'Câble USB-C tressé 50 cm': 'braided_cable_50',
      'MagSafe + porte-carte + cordon': 'gift_contents_short',
    };
    if (composerExact[value] && composerText(composerExact[value])) {
      return composerText(composerExact[value]);
    }

    var match = value.match(/^(\d+) CHARGEUR(?:S)?$/);
    if (match) {
      var quantity = Number(match[1]);
      return text(quantity === 1 ? 'charger_one' : 'charger_other', {
        count: quantity,
      }).toUpperCase();
    }

    match = value.match(/^(\d+) chargeur(?:s)?$/);
    if (match) {
      var chargerQuantity = Number(match[1]);
      return text(
        chargerQuantity === 1 ? 'charger_one' : 'charger_other',
        { count: chargerQuantity },
      );
    }

    match = value.match(/^(.+?)\s*\/\s*chargeur$/);
    if (match) return match[1] + ' ' + text('per_charger');

    match = value.match(/^Chargeur #?(\d+)$/);
    if (match) {
      var chargerPrefix = composerText('charger_hash');
      return chargerPrefix
        ? chargerPrefix + match[1]
        : text('charger_slot', { count: match[1] });
    }

    match = value.match(/^(\d+) modèles$/);
    if (match) return text('models_count', { count: match[1] });

    match = value.match(/^(\d+) coque(?:s)?$/);
    if (match) {
      var caseQuantity = Number(match[1]);
      return text(caseQuantity === 1 ? 'case_one' : 'case_other', {
        count: caseQuantity,
      });
    }

    match = value.match(/^Coques MagSafe \((\d+)\)$/);
    if (match) return text('magsafe_cases', { count: match[1] });

    match = value.match(/^Remise (.+?)( \(−25 %\))$/);
    if (match) {
      return (
        text('discount') +
        ' ' +
        translateFormulaName(match[1]) +
        match[2]
      );
    }

    match = value.match(/^(.+?) \((\d+) chargeur(?:s)?\)$/);
    if (match) {
      var formulaCount = Number(match[2]);
      return (
        translateFormulaName(match[1]) +
        ' (' +
        text(formulaCount === 1 ? 'charger_one' : 'charger_other', {
          count: formulaCount,
        }) +
        ')'
      );
    }

    match = value.match(/^Pack cadeau offert( × \d+)?$/);
    if (match) return text('gift_pack_free') + (match[1] || '');

    match = value.match(/^Coque MagSafe( #\d+)?(.*)$/);
    if (match) return text('magsafe_case') + (match[1] || '') + (match[2] || '');

    match = value.match(/^Livraison gratuite — (.+)\.$/);
    if (match) {
      return (
        text('estimated_delivery') +
        ' — ' +
        translateMonths(match[1]) +
        '. ' +
        text('free_over_50') +
        '.'
      );
    }

    if (value.indexOf('Expédié sous 24 heures · Livraison gratuite') === 0) {
      var legacyDelivery = value
        .slice('Expédié sous 24 heures · Livraison gratuite'.length)
        .replace(/^\s*—\s*/, '');
      return (
        text('shipped_free') +
        (legacyDelivery
          ? ' ' +
            text('estimated_delivery') +
            ' — ' +
            translateMonths(legacyDelivery)
          : '')
      );
    }

    match = value.match(/^Du (.+) au (.+)$/);
    if (match) {
      return text('date_from_to', {
        start: translateMonths(match[1]),
        end: translateMonths(match[2]),
      });
    }

    match = value.match(/^plus que (\d+) h (\d+) min$/);
    if (match) {
      return text('countdown_remaining', {
        hours: match[1],
        minutes: match[2],
      });
    }

    match = value.match(/^pour (\d+) chargeur(?:s)? · (.+) \/ chargeur$/);
    if (match) {
      var covered = Number(match[1]);
      return (
        text('chargercare_for', {
          count: text(covered === 1 ? 'charger_one' : 'charger_other', {
            count: covered,
          }),
        }) +
        ' · ' +
        match[2] +
        ' ' +
        text('per_charger')
      );
    }

    match = value.match(
      /^ChargerCare — Garantie 5 ans · (.+) \/ chargeur\. Couvre casse, panne, batterie pendant 5 ans\.$/,
    );
    if (match) return text('chargercare_desc', { price: match[1] });

    match = value.match(/^Ajouter pour (.+)$/);
    if (match) return text('add_for', { price: match[1] });

    match = value.match(/^(Couleur|Puissance|Garantie 5 ans|Gravure personnalisée|Lié à votre pack|Modèle|Offert avec votre pack)(\s*:.*)$/);
    if (match) {
      var propertyKeys = {
        Couleur: 'property_color',
        Puissance: 'property_power',
        'Garantie 5 ans': 'property_warranty',
        'Gravure personnalisée': 'property_engraving',
        'Lié à votre pack': 'property_linked',
        Modèle: 'property_model',
        'Offert avec votre pack': 'property_free_pack',
      };
      return text(propertyKeys[match[1]]) + match[2].replace(/: Oui$/, ': ' + text('yes'));
    }

    var translated = translateMonths(value);
    translated = translated
      .split("L'essentiel").join(text('formula_essential'))
      .split('Le Duo').join(text('formula_duo'))
      .split('La Famille').join(text('formula_family'));
    return translated;
  }

  function translateFormulaName(value) {
    return value
      .split("L'essentiel").join(text('formula_essential'))
      .split('Le Duo').join(text('formula_duo'))
      .split('La Famille').join(text('formula_family'));
  }

  function replaceNodeText(node) {
    if (!node.nodeValue || !node.nodeValue.trim()) return;
    var leading = node.nodeValue.match(/^\s*/)[0];
    var trailing = node.nodeValue.match(/\s*$/)[0];
    var core = node.nodeValue.trim();
    var translated = translateCore(core);
    if (translated !== core) {
      node.nodeValue = leading + translated + trailing;
    }
  }

  function localizeAttributes(scope) {
    (scope.querySelectorAll ? scope.querySelectorAll('[data-tip], [aria-label]') : []).forEach(
      function (element) {
        var tip = element.getAttribute('data-tip');
        if (tip && tip.indexOf('Module de charge 25W') === 0) {
          element.setAttribute('data-tip', text('tooltip_power'));
        } else if (tip && tip.indexOf('Couvre la casse') === 0) {
          element.setAttribute('data-tip', text('tooltip_warranty'));
        } else if (tip && tip.indexOf('MagSafe : technologie') === 0) {
          element.setAttribute('data-tip', text('tooltip_magsafe'));
        }

        var aria = element.getAttribute('aria-label');
        if (aria === 'Promotion en cours') {
          element.setAttribute('aria-label', text('promo_aria'));
        } else if (aria === 'Retirer une coque') {
          element.setAttribute('aria-label', text('remove_case_aria'));
        } else if (aria === 'Ajouter une coque') {
          element.setAttribute('aria-label', text('add_case_aria'));
        } else if (aria === 'Ajouter') {
          element.setAttribute('aria-label', text('add_generic'));
        }
      },
    );
  }

  function localize(scope) {
    var root = scope && scope.nodeType === 1 ? scope : document;
    if (
      root !== document &&
      !root.closest(
        '[data-apple-composer], .apple-cart-page, .apple-cart-reco, .apple-cart-ugc-section, .apple-cart-faq-section, .apple-toast',
      ) &&
      !root.querySelector(
        '[data-apple-composer], .apple-cart-page, .apple-cart-reco, .apple-cart-ugc-section, .apple-cart-faq-section, .apple-toast',
      )
    ) {
      return;
    }

    root.querySelectorAll('.acr-text').forEach(function (element) {
      if (
        element.children.length === 0 &&
        element.textContent.indexOf('<strong>') >= 0
      ) {
        element.innerHTML = element.textContent;
      }
    });

    var walker = document.createTreeWalker(
      root,
      NodeFilter.SHOW_TEXT,
      null,
    );
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(replaceNodeText);
    localizeAttributes(root);
  }

  localize(document);

  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === Node.TEXT_NODE) {
          replaceNodeText(node);
        } else if (node.nodeType === Node.ELEMENT_NODE) {
          localize(node);
        }
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
})();
